import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Calendar, MapPin, ArrowRight } from "lucide-react";
import api from "../lib/api";

export default function EventsPage() {
  const [events, setEvents] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    api.get("/events").then((r) => setEvents(r.data)).finally(() => setLoading(false));
  }, []);

  const fmt = (d) => new Date(d).toLocaleDateString("fr-FR", { day: "2-digit", month: "long", year: "numeric" });

  return (
    <div data-testid="events-page">
      <section className="bg-ink text-white py-20 grain relative">
        <div className="max-w-7xl mx-auto px-6 lg:px-12">
          <div className="eyebrow eyebrow-on-dark"><span className="w-8 h-px bg-gold inline-block align-middle mr-3" />Événements</div>
          <h1 className="font-serif text-5xl lg:text-6xl mt-6 leading-tight tracking-tight">
            Nos rendez-vous <span className="text-gold italic font-light">à travers la diaspora.</span>
          </h1>
          <p className="mt-8 text-white/75 max-w-2xl text-lg leading-relaxed">
            Conférences, marches pacifiques, galas, plaidoyer parlementaire : retrouvez l'agenda complet du Front Uni pour la RDC.
          </p>
        </div>
      </section>

      <section className="py-20 bg-bone">
        <div className="max-w-7xl mx-auto px-6 lg:px-12">
          {loading ? <div className="text-foreground/60">Chargement…</div> :
            events.length === 0 ? <div className="text-foreground/60">Aucun événement publié.</div> : (
            <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6">
              {events.map((ev) => (
                <Link
                  key={ev.id}
                  to={`/evenements/${ev.slug}`}
                  className="group bg-white border border-border rounded-sm overflow-hidden hover:border-ink/40 hover:shadow-lg transition-all"
                  data-testid={`event-${ev.slug}`}
                >
                  <div className="aspect-[16/10] bg-ink/5 overflow-hidden relative">
                    {ev.images?.[0] ? (
                      <img src={ev.images[0]} alt="" className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-700" />
                    ) : (
                      <div className="w-full h-full grid place-items-center text-gold-dark">
                        <Calendar className="w-12 h-12" />
                      </div>
                    )}
                    <div className="absolute top-3 left-3 bg-ink text-white text-[0.7rem] tracking-[0.2em] uppercase font-semibold px-3 py-1.5 rounded-sm">
                      {fmt(ev.date)}
                    </div>
                  </div>
                  <div className="p-6">
                    <div className="eyebrow text-gold-dark">{ev.theme}</div>
                    <h3 className="font-serif text-2xl text-ink mt-2 leading-tight">{ev.title}</h3>
                    <div className="mt-4 flex items-center gap-2 text-sm text-foreground/70">
                      <MapPin className="w-4 h-4 text-gold-dark" /> {ev.city}, {ev.country}
                    </div>
                    <div className="mt-5 inline-flex items-center gap-1.5 text-ink font-semibold text-sm group-hover:gap-3 transition-all">
                      Découvrir <ArrowRight className="w-4 h-4" />
                    </div>
                  </div>
                </Link>
              ))}
            </div>
          )}
        </div>
      </section>
    </div>
  );
}
